<template>
  <div
    style="display: flex; flex-direction: column; height: calc(100vh - 180px)"
  >
    <div style="display: flex; flex-wrap: wrap">
      <div class="condition-item">
        <label class="fn-14">校拍任务名称</label>
        <el-input
          v-model="searchObj.title"
          placeholder="请输入学校名称"
          autocomplete="off"
          size="small"
        ></el-input>
      </div>
      <!-- <div class="condition-item">
                <label class="fn-14">学校</label>
                <el-input v-model="searchObj.schoolName" placeholder="请输入学校名称" autocomplete="off"
                    size="small"></el-input>
            </div> -->
      <div class="condition-item">
        <label class="fn-14">采集时间</label>
        <el-date-picker
          v-model="searchObj.startTime"
          type="date"
          format="yyyy 年 MM 月 dd 日"
          value-format="yyyy-MM-dd"
          placeholder="选择开始时间"
          autocomplete="off"
          size="small"
          style="width: 160px"
        >
        </el-date-picker>
        <label class="fn-14" style="padding-left: 10px">-</label>
        <el-date-picker
          v-model="searchObj.endTime"
          type="date"
          format="yyyy 年 MM 月 dd 日"
          value-format="yyyy-MM-dd"
          placeholder="选择结束时间"
          autocomplete="off"
          size="small"
          style="width: 160px"
        >
        </el-date-picker>
      </div>
      <div class="condition-item">
        <el-button
          type="primary"
          icon="el-icon-search"
          @click="handleSearch"
          size="small"
          >查询
        </el-button>
      </div>
    </div>
    <div style="display: flex; margin-bottom: 15px">
      <el-card style="width: 33.33%; margin-right: 20px">
        <div>
          <div style="margin-bottom: 20px">采集总人数</div>
          <div>{{ collectCount }}</div>
        </div>
      </el-card>
      <el-card style="width: 33.33%; margin-right: 20px">
        <div>
          <div style="margin-bottom: 20px">授权总人数</div>
          <div>{{ yunNumSumCount }}</div>
        </div>
      </el-card>
      <el-card style="width: 33.33%">
        <div>
          <div style="margin-bottom: 20px">同步成功总人数</div>
          <div>{{ sycCountCount }}</div>
        </div>
      </el-card>
    </div>
    <div style="margin-bottom: 15px; flex: 1; overflow: hidden">
      <el-table
        :data="taskList"
        v-loading="tableLoading"
        stripe
        border
        height="100%"
        style="width: 100%"
        :header-cell-style="{ background: '#f5f7fa', color: '#606266' }"
      >
        <template #empty>
          <p>{{ tableLoading == true ? "数据加载中" : "暂无数据" }}</p>
        </template>
        <el-table-column prop="code" label="任务编号"></el-table-column>
        <el-table-column prop="title" label="任务名称"></el-table-column>
        <el-table-column prop="beginDate" align="center" label="采集时间">
          <template slot-scope="scope">
            {{ columnDateFormat(scope.row.beginDate) }} -
            {{ columnDateFormat(scope.row.endDate) }}
          </template>
        </el-table-column>
        <el-table-column prop="collectType" align="center" label="采集类型">
          <template slot-scope="scope">
            <el-tag
              v-if="scope.row.collectType == 0"
              type="success"
              size="small"
              effect="plain"
              >校拍</el-tag
            >
            <el-tag
              v-else-if="scope.row.collectType == 1"
              type="danger"
              size="small"
              effect="plain"
              >散拍</el-tag
            >
          </template>
        </el-table-column>
        <el-table-column
          prop="completePayNumSum"
          align="center"
          label="采集人数"
        ></el-table-column>
        <el-table-column
          prop="yunNumSum"
          align="center"
          label="授权人数"
        ></el-table-column>
        <el-table-column
          prop="sycCount"
          align="center"
          label="同步文件成功数"
        ></el-table-column>
        <el-table-column
          prop="orderNo"
          align="center"
          label="云盘开通数"
        ></el-table-column>
        <el-table-column
          prop="orderNo"
          align="center"
          label="使用云盘数"
        ></el-table-column>
        <!-- <el-table-column prop="orderNo" label="操作"></el-table-column> -->
      </el-table>
    </div>
    <div style="display: flex; justify-content: right">
      <el-pagination
        :current-page="pageConf.page"
        :page-sizes="[10, 20, 30, 40, 50, 100]"
        :page-size="pageConf.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="pageConf.total"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      >
      </el-pagination>
    </div>
  </div>
</template>
<script>
import { queryTasks, queryTasksSummary } from "@/api/yunpan";
import { dateFormat } from "@/utils/date";
export default {
  name: "xpTaskList",
  data() {
    return {
      tableLoading: false,
      taskList: [],
      collectCount: 0,
      yunNumSumCount: 0,
      sycCountCount: 0,
      searchObj: {
        title: "",
        // schoolName: '',
        startTime: "",
        endTime: "",
      },
      pageConf: {
        page: 1,
        pageSize: 20,
        total: 0,
      },
    };
  },
  methods: {
    //查询
    handleSearch() {
      this.pageConf.page = 1;
      this.fucnqueryTasks();
    },
    //分页
    handleCurrentChange(val) {
      this.pageConf.page = val;
      this.fucnqueryTasks();
    },
    //显示条数
    handleSizeChange(val) {
      this.pageConf.page = 1;
      this.pageConf.pageSize = val;
      this.fucnqueryTasks();
    },
    async fucnqueryTasks() {
      this.tableLoading = true;
      try {
        const _obj = await queryTasksSummary(this.searchObj);
        this.collectCount = _obj.data.collectCount || 0;
        this.yunNumSumCount = _obj.data.yunNumSumCount || 0;
        this.sycCountCount = _obj.data.sycCountCount || 0;
        const res = await queryTasks(
          this.searchObj,
          this.pageConf.page,
          this.pageConf.pageSize
        );
        this.taskList = res.data.content;
        this.pageConf.total = res.data.totalElements;
        this.tableLoading = false;
      } finally {
        this.tableLoading = false;
      }
    },
    columnDateFormat(dateValue) {
      return dateFormat("YYYY-mm-dd", new Date(dateValue));
    },
  },
  mounted() {
    this.fucnqueryTasks();
  },
};
</script>
